module.exports = __webpack_public_path__ + "img/ic_mpe_chair_sm1_normal.ceb5df12.png";